import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { ciInterface } from 'src/app/util/interfaces/ci';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CmdbQrcodeService {
	private getCiBasicDataUrl = environment.baseApiUrl + 'qrcode/cmdb/{searchParam}';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getCiBasicData(searchParameter: string): Observable<ciInterface['ciArray'][number]> {
		const getCiBasicDataUrl = this.getCiBasicDataUrl.replace('{searchParam}', searchParameter);
		return this.http.get<any>(getCiBasicDataUrl).pipe(
			map((ciBasicData) => {
				const newCiData: ciInterface['ciArray'][number] = {
					id: ciBasicData.id,
					cmdb_id: ciBasicData.id,
					identification: ciBasicData.identification,
					type: ciBasicData.label,
					idCiType: ciBasicData.type,
				};

				return newCiData;
			})
		);
	}
}
